
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import {baseUrl, limit} from "../../../comman/config";
import { can } from "../../../comman/permissions";
import { useNavigate, Link } from 'react-router-dom';
import ColumnFilterRow from "../../../components/Filter/ColumnFilterRow";
import { isFilterActive, matchFilterText, patchFilter } from "../../../components/Filter/columnFilter";
import Loader from "../../../components/Loader";
// import Pagination from "react-js-pagination";

// The table's columns, in order: the header row, the filter row and the cells are all built from
// this one list. Action holds buttons and is not filterable; it still needs a cell in the filter
// row or every column below it shifts.
const COLS = [
    { key: 'name',                  label: 'Bowl Name',            type: 'text',   text: (i) => i.name },
    { key: 'bowl_weight_empty',     label: 'Empty Weight (kgs)',                   text: (i) => i.bowl_weight_empty },
    { key: 'bowl_color',            label: 'Notes',                type: 'text',   text: (i) => i.bowl_color },
    { key: 'bowl_diameter_bottom',  label: 'Bottom Dia (cms)',                     text: (i) => i.bowl_diameter_bottom },
    { key: 'bowl_diameter_marked',  label: 'Marked Dia (cms)',                     text: (i) => i.bowl_diameter_marked },
    { key: 'bowl_diameter_top',     label: 'Top Dia (cms)',                        text: (i) => i.bowl_diameter_top },
    { key: 'bowl_marked_height',    label: 'Marked Height (cms)',                  text: (i) => i.bowl_marked_height },
    { key: 'bowl_total_height',     label: 'Total Height (cms)',                   text: (i) => i.bowl_total_height },
    { key: 'bowl_marked_volume',    label: 'Marked Volume (ltrs)',                 text: (i) => i.bowl_marked_volume },
    { key: 'bowl_top_volume',       label: 'Total Volume (ltrs)',                  text: (i) => i.bowl_top_volume },
    { key: 'status',                label: 'Status',               type: 'status', text: (i) => (Number(i.status) === 1 ? 'Active' : 'Inactive') },
    { key: 'action',                label: 'Action',               filterable: false },
];

function List() {

    const [bowlMasterList, setBowlMasterList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    const [popupOpen, setPopupOpen] = useState(false);
    // Inline per-column filters, as the Raw Report has them, in place of the single search box
    // that used to sit above the table.
    const [filters, setFilters] = useState({});

    // role 0 = superadmin, 1 = admin. Both may enable and disable; only the superadmin may delete.
    const role = String(localStorage.getItem('userRole'));
    // Which buttons this user gets is Role Master's call now, not a role number's -- see
    // comman/permissions.js. `role` is still read because it is what the delete and enable
    // endpoints are told to check against.
    const canDisable = can('disable');
    const canActivate = can('active');
    const canDelete = can('delete');

    const navigate = useNavigate();

    useEffect(() => {
        getBowlMaster();
        
    }, []);

    // Every active column filter must pass, matched against the same text the cell shows.
    const activeCols = COLS.filter((c) => c.filterable !== false && isFilterActive(filters[c.key]));
    const visibleRows = bowlMasterList.filter((item) => activeCols.every((c) => matchFilterText(c.text(item), filters[c.key])));
    const onFilterChange = (key, patch) => setFilters((prev) => patchFilter(prev, key, patch));
    const clearFilters = () => setFilters({});



    const getBowlMaster = async () => {
        // try/finally, because the spinner this sets is now on screen: a request that fails --
        // which on a slow connection is the case it exists for -- used to skip the line that
        // turns it off and leave it spinning over an empty table for good.
        setPopupOpen(true);
        try {
            const response = await axios.get(`${baseUrl}/bowl_master/list?page=${page}&limit=${limit}`);
            setBowlMasterList(response.data.data);
            setTotalItem(response.data.totalItem);
        } catch (error) {
            console.log(error);
            alert('Could not load the list. Check the connection and try again.');
        } finally {
            setPopupOpen(false);
        }
    }


    // const deleteVessel = async (id) => {
    //     const shouldDelete = window.confirm("Are you sure you want to disable this ingredient?");
    //     if (shouldDelete) {
    //         try {
    //             await axios.delete(`${baseUrl}/ingredients/delete/${id}`);
    //             window.location.reload();
    //         } catch (error) {
    //             console.log(error);
    //         }
    //     }
    // };


    const enableBowl = async (id) => {
        if (!window.confirm("Enable this bowl?")) return;
        try {
            await axios.post(`${baseUrl}/bowl_master/enable/${id}`, { role });
            window.location.reload();
        } catch (error) {
            alert(error?.response?.data?.msg ?? 'Could not enable the bowl.');
        }
    };

    // Delete removes the row, unlike Disable which is recoverable, so its confirmation says so.
    const destroyBowl = async (id) => {
        if (!window.confirm("Permanently DELETE this bowl? Disable is reversible; this is not.")) return;
        try {
            await axios.delete(`${baseUrl}/bowl_master/destroy/${id}`, { data: { role } });
            window.location.reload();
        } catch (error) {
            alert(error?.response?.data?.msg ?? 'Could not delete the bowl.');
        }
    };

    const editBowlMaster = async (id) => {
        navigate(`/bowl_master/edit/${btoa(id)}`, { state: bowlMasterList.filter(item => item.id == id) });
    }

    const deleteVessel = async (id) => {
        const shouldDelete = window.confirm("Are you sure you want to disable this bowl?");
        if (shouldDelete) {
            try {
                await axios.delete(`${baseUrl}/bowl_master/delete/${id}`, { data: { role } });
                window.location.reload();
            } catch (error) {
                console.log(error);
            }
        }
    };
   


    return (
        <div className="p-4">
            {popupOpen && <Loader />}
            <div className="flex justify-between items-center py-4 px-6">
                <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">Bowl Master</h1>
                <div>
                    <Link to="/bowl_master/add">
                        <button className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Add Bowl</button>
                    </Link>
                </div>
            </div>
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                {/* The search box that used to sit here is gone: the filters are in the header
                    row now, one per column, so a search is made where the column is read. */}
                <div className="flex items-center justify-end pb-4">
                    <button
                        onClick={clearFilters}
                        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
                    >
                        Clear
                    </button>
                </div>
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        {/* One header row. The grouping row above this said "Bowl Diameter" over
                            three columns already reading Bottom, Marked and Top -- it named what
                            the headings under it were saying, and its spans had to be kept in step
                            with the leaves by hand. Each column names itself in full now. */}
                        <tr>
                            {COLS.map((c) => <th key={c.key} scope="col" className="px-6 py-3 border">{c.label}</th>)}
                        </tr>
                        <ColumnFilterRow
                            cols={COLS}
                            filters={filters}
                            onChange={onFilterChange}
                            thClassName="px-2 py-1 border bg-gray-50 align-top"
                        />
                    </thead>
                    <tbody>
                    {visibleRows.map((item) => (
                        <tr key={item.id} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                            <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{item.name}</th>
                            <td className="px-6 py-4">{item.bowl_weight_empty}</td>
                            <td className="px-6 py-4">{item.bowl_color}</td>
                            <td className="px-6 py-4">{item.bowl_diameter_bottom}</td>
                            <td className="px-6 py-4">{item.bowl_diameter_marked}</td>
                            <td className="px-6 py-4">{item.bowl_diameter_top}</td>
                            <td className="px-6 py-4">{item.bowl_marked_height}</td>
                            <td className="px-6 py-4">{item.bowl_total_height}</td>
                            <td className="px-6 py-4">{item.bowl_marked_volume}</td>
                            <td className="px-6 py-4">{item.bowl_top_volume}</td>
                            <td className="px-6 py-4">{Number(item.status) === 1 ? 'Active' : 'Inactive'}</td>
                            <td className="px-6 py-4">
                            <div className="flex gap-2">
                                <button
                                    type="button"
                                    onClick={() => editBowlMaster(item.id)}
                                    className="px-3 py-1 text-sm bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">
                                    Edit
                                </button>
                                {item.status == 1 && canDisable && <button
                                    type="button"
                                    onClick={() => deleteVessel(item.id)}
                                    className="px-3 py-1 text-sm bg-red-500 text-white rounded-md hover:bg-red-600 focus:outline-none focus:ring focus:ring-red-200">
                                    Disable
                                </button>}
                                {item.status == 0 && canActivate && <button
                                    type="button"
                                    onClick={() => enableBowl(item.id)}
                                    className="px-3 py-1 text-sm bg-green-600 text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring focus:ring-green-200">
                                    Enable
                                </button>}
                                {canDelete && <button
                                    type="button"
                                    onClick={() => destroyBowl(item.id)}
                                    className="px-3 py-1 text-sm bg-red-700 text-white rounded-md hover:bg-red-800 focus:outline-none focus:ring focus:ring-red-300">
                                    Delete
                                </button>}
                            </div>
                            </td>
                        </tr>))}
           
                    </tbody>
                </table>
            </div>
        </div>
  );
}

export default List;